export enum UserRoleEnum {
    Profile = 1,
    Admin = 2,
    CustomerProfile = 3,
    SuperAdmin = 4
}
